import { useQueryUpdate } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { Select, SelectProps } from 'antd/lib'

export const IsTenderSelect = () => {
  const { t } = useLocales()
  const { params, updateQuery } = useQueryUpdate()

  const options: SelectProps['options'] = [
    { label: t('buttons.yes'), value: '1' },
    { label: t('buttons.no'), value: '0' }
  ]

  return (
    <Select
      placeholder={t('opportunities.is_tender')}
      className="w-full"
      options={options}
      value={params.is_tender}
      onChange={(value) => updateQuery({ is_tender: value, page: 1 })}
      allowClear
    />
  )
}
